import React, { Component } from "react"
import { famdyauth, famdydb } from '../../../service';
import swal from 'sweetalert';

export class FormUpdate extends Component {

    constructor(props) {
        super(props)
        this.state = {
            dare: {},
        }
    }

    componentDidMount(){
       const id = this.props.match.params.id
       const dare = this.props.match.params.dare
       console.log(id, dare)
       famdydb.collection(dare).doc(id).get().then((querySnapshot) => {
            const data = querySnapshot.data()
            this.setState({dare})
        }).catch((error) => {
            swal("Алдаа!", error, "error");
        })

    }
    render() {
        const user_id = this.props.match.params.user_id
        const {dare} = this.state
        return (
            <div className="main-content">
                {user_id}

            </div>
        )

    }

}
